import { render } from "./SeparationTermination.vue?vue&type=template&id=8e0d2c50&scoped=true"
import script from "./SeparationTermination.vue?vue&type=script&lang=js"
export * from "./SeparationTermination.vue?vue&type=script&lang=js"

import "./SeparationTermination.vue?vue&type=style&index=0&id=8e0d2c50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e0d2c50"]])

export default __exports__